(function($) {
  'use strict';

  const ctas = {
    dom: function() {
      this.$homeCTAs = $('#homeCTAs');
    },

    initialize: function() {
      function setDrag(element, event) {
        let itemsCount = event.item.count || element.$element.children().length;
        let itemsTotal = element.settings.items;
        if (itemsCount <= itemsTotal) {
          element.options.dots = false;
          element.options.mouseDrag = false;
          element.options.touchDrag = false;
        }
        else {
          element.options.dots = true;
          element.options.mouseDrag = true;
          element.options.touchDrag = true;
        }
        element.trigger('refresh.owl.carousel');
      }

      this.$homeCTAs.addClass('owl-carousel owl-theme').owlCarousel({
        nav: false,
        dots: false,
        margin: 20,
        stagePadding: 0,
        responsive: {
          0: {
            dots: false,
            margin: 20,
            stagePadding: 30,
            items: 1
          },
          661: {
            margin: 30,
            stagePadding: 50,
            items: 1.5
          },
          808: {
            margin: 30,
            stagePadding: 50,
            items: 1.5
          },
          981: {
            margin: 30,
            items: 3
          },
          1180: {
            margin: 50,
            items: 3
          }
        },
        onInitialize: function(event) {
          setDrag(this, event);

          setTimeout(() => {
            let $dots = this.$element.find('.owl-dot');

            if ($dots.length) {
              $dots.each((index, item) => {
                $(item).attr('aria-label', 'Go to slide ' + (index + 1));
              });
            }
          }, 100);
        }
      });
    },

    ready: function() {
      this.dom();
      this.initialize();
    }
  };

  $(function() { ctas.ready(); });

})(jQuery);
